import { createSlice } from '@reduxjs/toolkit';

export interface IReportState {}

const initialState: IReportState = {};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {},
});

export const reportActions = reportSlice.actions;

const reportReducer = reportSlice.reducer;
export default reportReducer;
